export default __webpack_public_path__ + "static/media/Green Visa - Investment.f4490e10.jpg";